<template>
  <v-carousel cycle height="auto" hide-delimiters>
    <v-carousel-item v-for="(slide, i) in slides" :key="i" eager>
      <a :href="slide.link"><v-img eager :src="slide.url" :alt="`${slide.title}`" /></a>
    </v-carousel-item>
  </v-carousel>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";

import getBanners from "@/api/requests/getBanners";
import Banner from "@/types/Banner";
import { WhitelabelProducer } from "@/types/Producer";

export default Vue.extend({
  name: "TImagesCarousel",

  props: {
    id: {
      required: false,
      default: "0",
      type: String as PropType<string>,
    },
  },

  data() {
    return {
      slides: [] as Banner[],
    };
  },

  computed: {
    isMobile(): boolean {
      return this.$vuetify.breakpoint.xs;
    },
    producerID(): string {
      const { id: whiteLabelID } = this.$store.state.producers.selected as WhitelabelProducer;
      return whiteLabelID !== "0" ? whiteLabelID : this.id;
    },
  },
  async mounted() {
    this.slides = await getBanners(this.producerID, this.isMobile ? "mobile" : "desktop");
  },
});
</script>
